import { useEffect } from 'react'

/**
 * Overlays stack, and each one wants the page behind it still. Counting is
 * what keeps the innermost from handing scrolling back while an outer one is
 * still open, which is the bug when each sets `overflow` on its own.
 */
let lockCount = 0
let restoreOverflow: string | null = null

const acquire = (): void => {
    lockCount += 1
    if (lockCount > 1) return
    restoreOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
}

const release = (): void => {
    lockCount = Math.max(0, lockCount - 1)
    if (lockCount > 0) return
    document.body.style.overflow = restoreOverflow ?? ''
    restoreOverflow = null
}

export const useBodyScrollLock = (locked: boolean): void => {
    useEffect(() => {
        if (!locked) return
        acquire()
        return release
    }, [locked])
}
